export default __webpack_public_path__ + "locales/cs/DataReassignmentDialog.json?hash=b51affd6b87e05b0c91c17bbff9c3672";